import Image from 'next/image'
import Link from 'next/link'
import React, { ReactNode } from 'react'
import styled from 'styled-components'

import { BannerUnholster } from '@/app/components/Banner'
import { colors, spaces } from '@/config/global-parameters'

interface ISponsor {
  name: string
  headerText: string
  href: string
  logo: ReactNode
  footerText: string
}

interface IFooter {
  sponsors?: ISponsor[]
}

const Footer = ({ sponsors = [] }: IFooter) => (
  <Wrapper>
    <BannerUnholster />
    <Companies>
      <Company>
        <Link
          href="https://www.unholster.com"
          passHref
          rel="noopener noreferrer"
          target="_blank"
        >
          <Image
            alt="Unholster"
            height={41}
            priority
            src="/images/powered-unholster.svg"
            width={145}
          />
        </Link>
      </Company>
      {sponsors.map((sponsor) => (
        <Company key={sponsor.name}>
          <HeaderText>{sponsor.headerText}</HeaderText>
          <Link
            href={sponsor.href}
            passHref
            rel="noopener noreferrer"
            target="_blank"
          >
            {sponsor.logo}
          </Link>
        </Company>
      ))}
    </Companies>
    <Quote>Hecho con cariño.</Quote>
  </Wrapper>
)

const Wrapper = styled.div`
  max-width: ${spaces.maxContent};
  display: flex;
  flex-direction: column;
  padding: 0 1rem 4rem 1rem;
  gap: ${spaces.xs};
`

const Companies = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 2rem;
`

const Company = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 100%;
`
const HeaderText = styled.div`
  color: ${colors.colorBlack};
  font-weight: 400;
  text-align: center;
  font-size: 11px;
`

const Quote = styled.div`
  font-size: 14px;
  text-align: center;
`

export default Footer
